/**
 * The supplier portal's languages, as the API names them (`locale` on a
 * user, eudr-api lib/locales.ts). English is the source; the others are
 * translations of the portal and of the taxonomy's names.
 */
export const PORTAL_LANGUAGES = [
  { code: 'en', native: 'English', english: 'English' },
  { code: 'es', native: 'Español', english: 'Spanish' },
  { code: 'pt-BR', native: 'Português (Brasil)', english: 'Portuguese (Brazil)' },
  { code: 'zh-CN', native: '简体中文', english: 'Chinese (Simplified)' },
  { code: 'th', native: 'ไทย', english: 'Thai' },
  { code: 'ko', native: '한국어', english: 'Korean' },
] as const

export type PortalLanguage = (typeof PORTAL_LANGUAGES)[number]['code']
